<div class="not-found">
  <div class="container text-center">
    <img class="icon mb-3" src="/assets/images/not-found.svg" />

    <h1 class="page-title text-primary" translate>Oops! | Page not found</h1>
    <p translate>The page you are looking for can be found.</p>

    <a class="btn btn-primary btn-lg rounded-pill" routerLink=".." translate>Go Back</a>
  </div>
</div>
